import { UserVoiceNpsState } from 'owa-uservoice/lib/store/schema/UserVoiceNpsState';
import { UserVoiceSuggestionState } from 'owa-uservoice/lib/store/schema/UserVoiceSuggestionState';
import { createStore } from 'satcheljs';
import { UserVoiceIdeasResponse } from 'owa-uservoice/lib/store/schema/UserVoiceIdeasResponse';

var initialUserVoiceNpsState: UserVoiceNpsState = {
    npsSurveyBody: '',
    npsSurveyRatings: '',
    isRatingSelected: false,
    isSent: false,
};

var initialUserVoiceSuggestionState: UserVoiceSuggestionState = {
    message: '',
    isMessageEnabled: false,
    isSent: false,
    customFields: [],
};

export let userVoiceNpsStore = createStore<UserVoiceNpsState>(
    'UserVoiceNpsStore',
    initialUserVoiceNpsState
);

export let userVoiceSuggestionStore = createStore<UserVoiceSuggestionState>(
    'UserVoiceSuggestionStore',
    initialUserVoiceSuggestionState
)();

export let userVoiceTrendingIdeasStore = createStore<UserVoiceIdeasResponse>(
    'userVoiceTrendingIdeasStore',
    {
        suggestions: [],
        pagination: {
            page: 0,
            per_page: 0,
            total_pages: 0,
            total_records: 0,
        },
    }
);
